import { attach, createEffect, createEvent, type EffectParams, type EventPayload, sample } from 'effector'

import { portalProfileAPI } from '@/entities/profile/portal'
import { $lang } from '@/shared/lib/i18n'
import { type NotificationArgs, showNotificationFx } from '@/shared/ui'
import { createHideFx } from '@/shared/ui/modal'

export const showFx = createEffect<{ email: string }, string>()
export const hideFx = createHideFx(showFx)

export const buttonClicked = createEvent<{ email: string }>()

const resetPasswordFx = attach({
    effect: portalProfileAPI.passwordReset,
    source: $lang,
    mapParams: (
        { email }: EventPayload<typeof buttonClicked>,
        lang
    ): EffectParams<typeof portalProfileAPI.passwordReset> => ({
        lang,
        email,
    }),
})

sample({
    clock: buttonClicked,
    target: resetPasswordFx,
})

sample({
    clock: resetPasswordFx.done,
    fn: ({ params }): NotificationArgs => ({ notification: 'password_reset_link_sent', email: params.email }),
    target: showNotificationFx,
})

sample({
    clock: resetPasswordFx.fail,
    fn: (): NotificationArgs => ({ notification: 'error_default' }),
    target: showNotificationFx,
})

sample({
    clock: resetPasswordFx.finally,
    target: hideFx,
})

export const $interactionDisabled = resetPasswordFx.pending
